import React, {
  Fragment,
  useState,
  useEffect,
  useContext,
  useRef,
} from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import moment from "moment";
import { useLocation } from "react-router";
import { CSVLink } from "react-csv";
import { Download } from "react-feather/dist";

import FilterTable from "../../Common/Component/FilterTable";
import SearchTable from "../../Common/Component/SearchTable";
import { Breadcrumbs, Btn } from "../../../AbstractElements";
import { vendorBookingFilterColumns } from "../../../Data/Booking/BookingHistory";

import BookingContext from "../../../_helper/Booking";
import SharedDataContext from "../../../_helper/SharedData";

import {
  getCancelReasons,
  getBookingStatus,
  getBookingViaType,
} from "../../../Services/Booking.service";
import {
  showAlert,
  formatDateTime,
  getUserDetails,
} from "../../../Services/Shared.service";
import {
  getVendorBooking,
  getVendorBookingTableFilterData,
  getVendorBookingTableSearchData,
} from "../../../Services/Ventor.service";

import VendorBookingTable from "./VendorBookingTable";
import SelectedFilter from "../BookingHistory/SelectedFilter";

const VendorBookingHistory = () => {
  const location = useLocation();
  const userDetails = getUserDetails();

  const { setOnSubmitData, emptyCallback } = useContext(BookingContext);
  const { globalCityField, setPageNumber, dateFilter } =
    useContext(SharedDataContext);

  const localFromDate = moment(dateFilter.startDate).set({
    h: 0,
    m: 0,
    s: 0,
    ms: 0,
  });
  const localToDate = moment(dateFilter.endDate).set({
    h: 23,
    m: 59,
    s: 59,
    ms: 999,
  });
  const FormatFromDate = formatDateTime(localFromDate, "YYYY-MM-DD");
  const FormatToDate = formatDateTime(localToDate, "YYYY-MM-DD");

  const firstUpdate = useRef(true);

  const [searchData, setSearchData] = useState(
    location.state?.searchdata ? location.state?.searchdata : ""
  );
  const [loader, setLoader] = useState(false);
  const [filterType, setFilterType] = useState(
    location.state?.filterdata?.length > 0
      ? "filter"
      : location.state?.searchdata
      ? "search"
      : ""
  );
  const [vendorBookingData, setVendorBookingData] = useState([]);
  const [paginationTotalRows, setPaginationTotalRows] = useState(0);
  const [reasonData, setReasonData] = useState([]);
  const [pagination, setPagination] = useState(
    location.state?.pageNumber ? location.state.pageNumber : 0
  );
  const [rowsPerPage, setRowsPerPage] = useState(20);

  let filterFromLocation =
    location.state?.filterdata?.length > 0
      ? location.state?.filterdata.map((d) => {
          if (d?.key == "Pickup") {
            return {
              ...d,
              key: (
                <span>
                  <Fragment>
                    PICKUP <i className="fa fa-clock-o mr-2"></i>
                  </Fragment>
                </span>
              ),
            };
          } else {
            return d;
          }
        })
      : [];

  const [filterData, setFilterData] = useState(filterFromLocation);
  const [bookingStatusData, setBookingStatusData] = useState([]);
  const [bookingViaTypeData, setBookingViaTypeData] = useState([]);
  const [exportData, setExportData] = useState([]);

  let pickupTypeData = [
    {
      value: "AirportToCity",
      label: "AirportToCity",
    },
    {
      value: "CityToAirport",
      label: "CityToAirport",
    },
    {
      value: "CityToCity",
      label: "CityToCity",
    },
  ];

  let columns = [];
  const disableLoaders = () => {
    setLoader(false);
  };

  vendorBookingFilterColumns.map((element) => {
    if (element.value) {
      columns.push({
        value: {
          name: element.name,
          value: element.value,
          type: element.type,
        },
        label: element.name,
      });
    }
  });

  const removeFilter = (index) => {
    const newfilterData = [...filterData];
    newfilterData.splice(index, 1);
    setFilterData(newfilterData);
  };

  const fetchVendorBookingData = async ({ isSearchFilterPage }) => {
    const serviceCityId = globalCityField.value?.id?.toString() || 0;

    const obj = {
      aggregatorId: userDetails.aggregatorId ? userDetails.aggregatorId : null,
      serviceCityId: serviceCityId ? serviceCityId : 0,
      bookingDTO: {
        fromDate: FormatFromDate,
        toDate: FormatToDate,
      },
    };

    if (filterData.length == 0 && !searchData) {
      setLoader(true);
      getVendorBooking(obj)
        .then((result) => {
          setVendorBookingData(result.data.list);
          setPaginationTotalRows(result.data.count);
          disableLoaders();
        })
        .catch((error) => {
          disableLoaders();
          setVendorBookingData([]);
          showAlert("error", "Something went wrong");
        });
    } else if (filterData.length > 0 && filterType == "filter") {
      const body = {
        aggregatorId: userDetails.aggregatorId
          ? userDetails.aggregatorId
          : null,
        bookingDTO: {
          megaCabsBookingNo: null,
          custName: null,
          custMobile: null,
          pickupType: null,
          pickUpAddress: null,
          destAddress: null,
          serviceCityId: serviceCityId ? serviceCityId : 0,
          fromDate: FormatFromDate,
          toDate: FormatToDate,
        },
      };

      filterData.forEach((d) => {
        body.bookingDTO[d.column_name] = d["values"][0];
      });

      setLoader(true);

      getVendorBookingTableFilterData({ body })
        .then((result) => {
          if (result.data) {
            const data = result.data?.bookingList || [];
            setVendorBookingData(data);
            setPaginationTotalRows(result.data.count);
            disableLoaders();
          }
        })
        .catch((err) => {
          disableLoaders();
          setVendorBookingData([]);
          showAlert("error", "Something went wrong");
        });
    } else if (searchData && filterType == "search") {
      const obj = {
        aggregatorId: userDetails.aggregatorId
          ? userDetails.aggregatorId
          : null,
        serviceCityId: serviceCityId ? serviceCityId : 0,
        bookingDTO: {
          fromDate: FormatFromDate,
          toDate: FormatToDate,
        },
        custMobile: searchData,
      };

      setLoader(true);

      getVendorBookingTableSearchData({ obj, page: isSearchFilterPage })
        .then((result) => {
          if (result.data) {
            const data = result.data?.list || [];
            setVendorBookingData(data);
            setPaginationTotalRows(result.data.count);
            disableLoaders();
          }
        })
        .catch((err) => {
          disableLoaders();
          setVendorBookingData([]);
          showAlert("error", "Something went wrong");
        });
    }
  };

  useEffect(() => {
    setPageNumber(0);
    setOnSubmitData((prevData) => {
      return {
        ...prevData,
        fetchVendorBookingData: () => {
          fetchVendorBookingData({ isSearchFilterPage: pagination });
        },
      };
    });

    getCancelReasons().then((result) => {
      if (result.status == 200 && result.data.length > 0) {
        const data = [];
        result.data.forEach((element) => {
          if (element.isDeleted) return;
          data.push({
            value: element,
            label: `${element.reason} - ${element.cancelType}`,
          });
        });
        setReasonData(data);
      }
    });

    getBookingStatus().then((result) => {
      if (result.status == 200 && result.data.length > 0) {
        const data = [];
        result.data.forEach((element) => {
          data.push({
            value: element,
            label: element,
          });
        });
        setBookingStatusData(data);
      }
    });

    getBookingViaType().then((result) => {
      if (result.status == 200 && result.data.length > 0) {
        const data = [];
        result.data.forEach((element) => {
          data.push({
            value: element,
            label: element,
          });
        });
        setBookingViaTypeData(data);
      }
    });

    return () => {
      setOnSubmitData((prevData) => {
        return { ...prevData, fetchVendorBookingData: emptyCallback };
      });
    };
  }, []);

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    fetchVendorBookingData({ isSearchFilterPage: pagination });
  }, [dateFilter.startDate, dateFilter.endDate]);

  const onChangePage = (page) => {
    setPagination(page - 1);
  };

  const onChangeRowsPerPage = (currentRowsPerPage) => {
    setRowsPerPage(currentRowsPerPage);
  };

  useEffect(() => {
    if (filterData.length == 0 && filterType != "filter") return;
    setPagination(0);
    fetchVendorBookingData({ isSearchFilterPage: 0 });
  }, [filterData]);

  useEffect(() => {
    if (!searchData && filterType != "search") return;
    setPagination(0);
    fetchVendorBookingData({ isSearchFilterPage: 0 });
  }, [searchData]);

  useEffect(() => {
    fetchVendorBookingData({ isSearchFilterPage: pagination });
  }, [pagination, rowsPerPage, globalCityField.value]);

  useEffect(() => {
    if (vendorBookingData.length > 0) {
      let eData = vendorBookingData.map((d) => {
        return {
          "BOOKING #": d.megaCabsBookingNo,
          "PICKUP TIME": new Date(d.pickUpDateTime),
          "CUSTOMER NAME": d.custName,
          PHONE: d.custMobile,
          PICKUP: d.pickUpAddress,
          DROP: d.destAddress,
          STATUS: d.currentBookingStatusType,
          "BOOKING VIA": d.bookingViaType,
          "PICKUP TYPE": d.pickupType,
          "MMT ID": d.mmtReferenceId,
        };
      });
      setExportData(eData);
    }
  }, [vendorBookingData]);

  return (
    <Fragment>
      <Breadcrumbs
        parent="Trip Management"
        subParent="All Bookings"
        mainTitle="All Bookings"
        exportBtn={
          <Btn
            attrBtn={{
              style: {
                display: "flex",
                padding: "7px 14px 5px",
                justifyContent: "center",
                alignItems: "center",
              },
              title: "Export",
            }}
          >
            <CSVLink
              data={exportData}
              filename={"Vendor_Booking_History"}
              style={{ color: "white" }}
            >
              <Download size={"20px"} />
            </CSVLink>
          </Btn>
        }
        span1={
          <FilterTable
            options={columns}
            setFilterData={setFilterData}
            filterData={filterData}
            setSearchData={setSearchData}
            setFilterType={setFilterType}
            statusData={bookingStatusData}
            bookingViaTypeData={bookingViaTypeData}
            pickupTypeData={pickupTypeData}
          />
        }
        span3={
          <SearchTable
            searchData={searchData}
            setSearchData={setSearchData}
            setFilterData={setFilterData}
            setFilterType={setFilterType}
          />
        }
      />
      <Container fluid={true} className="datatables">
        <Row className="selected-filter">
          {filterData.map((element, i) => {
            return (
              <SelectedFilter
                key={i}
                element={element}
                index={i}
                removeFilter={removeFilter}
              />
            );
          })}
        </Row>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody className="p-0">
                <VendorBookingTable
                  reasonData={reasonData}
                  bookingData={vendorBookingData}
                  onSubmitData={{
                    fetchBookingData: () => fetchVendorBookingData({}),
                  }}
                  onChangePage={onChangePage}
                  paginationPerPage={rowsPerPage}
                  paginationTotalRows={paginationTotalRows}
                  onChangeRowsPerPage={onChangeRowsPerPage}
                  setShowApiLoader={setLoader}
                  pagination={pagination}
                  setPageNumber={setPageNumber}
                  pageNumber={
                    location.state?.pageNumber
                      ? location.state.pageNumber + 1
                      : 1
                  }
                  loader={loader}
                  filterData={filterData}
                  searchData={searchData}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default VendorBookingHistory;
